/**
 * "Powered by FlexiFunnels" branding link.
 * Mirrors the footer branding used in the FlexiContest frontend
 * (plug icon + FlexiFunnels logo + label, linking to flexifunnels.com).
 */
function PoweredByFlexiFunnels({ className = "" }) {
  return (
    <a
      href="https://flexifunnels.com"
      target="_blank"
      rel="noreferrer"
      className={`flex items-center justify-center text-gray-500 hover:text-gray-700 transition ${className}`}
    >
      <span className="mr-2">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="9.746"
          height="12.994"
          viewBox="0 0 9.746 12.994"
        >
          <path
            d="M8.121.812A.812.812,0,1,0,6.5.812V3.249H8.121ZM9.34,4.061H.406A.406.406,0,0,0,0,4.467v.812a.406.406,0,0,0,.406.406H.812V6.5a4.062,4.062,0,0,0,3.249,3.979v2.518H5.685V10.477A4.062,4.062,0,0,0,8.933,6.5V5.685H9.34a.406.406,0,0,0,.406-.406V4.467a.406.406,0,0,0-.406-.406ZM3.249.812a.812.812,0,1,0-1.624,0V3.249H3.249Z"
            fill="currentColor"
          />
        </svg>
      </span>
      <span className="text-[10px] md:text-[12px]">Powered by</span>
      <img
        src="https://img.flexifunnels.com/flexicontest/FlexiLogo.svg"
        alt="FlexiFunnels"
        className="mx-1 md:w-[18px] md:h-[18px] w-[15px] h-[15px]"
      />
      <span className="text-[10px] md:text-[12px] font-medium">FlexiFunnels</span>
    </a>
  );
}

export default PoweredByFlexiFunnels;
